import type { DeBetterDocInsurance } from "@/modules/patients/detail/better-doc/types"
import { Insurees } from "@/modules/patients/services/usePatientByIdQuery"
import { BetterDoc } from "@/types/__generated__/union-types"

const validBetterDocConfigurations: BetterDoc[] = ["ALLOWED", "REQUIRED", "CONDITION_PACKAGE"]

export const getDeBetterDocInsurance = (insurees: Insurees): DeBetterDocInsurance | null => {
  for (const insuree of insurees) {
    if (!insuree.insureeNumber) continue

    for (const coverage of insuree.activeCoverages) {
      const { productConfiguration, organisation } = coverage.product
      if (
        productConfiguration?.__typename === "de_ProductConfiguration" &&
        validBetterDocConfigurations.includes(productConfiguration.betterDoc)
      ) {
        return {
          insureeNumber: insuree.insureeNumber,
          insurerKey: organisation.key,
          productBetterDocKey: productConfiguration.betterDocKey,
        }
      }
    }
  }
  return null
}
